module.exports = __webpack_public_path__ + "pt.55a651f8.svg";